import { render, staticRenderFns } from "./WorkspaceOrganizationHeaderTemplate.vue?vue&type=template&id=02a3c064&scoped=true"
import script from "./WorkspaceOrganizationHeaderTemplate.vue?vue&type=script&lang=js"
export * from "./WorkspaceOrganizationHeaderTemplate.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceOrganizationHeaderTemplate.vue?vue&type=style&index=0&id=02a3c064&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a3c064",
  null
  
)

export default component.exports